var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type(_vm.error),{tag:"component",attrs:{"to":_vm.href(_vm.error),"replace":""}},[_vm._v("\n  "+_vm._s(_vm.children(_vm.error))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }